<template>
  <f-form-group
    v-if="can_show && field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    :label="field_label"
    v-b-tooltip="tooltip"
  >
    <b-form-input
      :label="field_label"
      :value="str_value"
      @input="on_input"
      disabled
      v-bind="field.params"
    ></b-form-input>
  </f-form-group>
</template>

<script>
import { setter } from "../setter";
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";
import { ParseProvider } from "../../utils/parse";

export default {
  name: "FormulaWidget",
  mixins: [FormWidgetMixin],
  components: { FFormGroup },
  methods: {
    evalExpr(item) {
      const $provider = ParseProvider();
      var filters = {};
      var $parser = $provider.$get(filters);
      const evalFunc = $parser(this.field.params.expression);

      if (evalFunc) {
        return evalFunc(item);
      } else {
        return null;
      }
    },
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(item) {
        var newVal = this.evalExpr(item);

        if (newVal !== this.field_value) {
          // Result Changed
          this.on_input(newVal);
        }
      },
    },
  },
  computed: {
    str_value() {
      return this.field_value + "";
    },
    can_show() {
      return this.field.params.show;
    },
  },
  created: function () {
    if (this.item && !(this.field.code in this.item)) {
      setter(this, this.item, this.field.code, {});
    }
  },
};
</script>
